/**
 * NOTE: this is a generated file that is produced at build time during
 * `treeForAddon`, if `publicOnly` is disabled.
 *
 * If `publicOnly` is enabled, we'll still want this empty export to be present,
 * to that the import in `-private/utils/hydrate.ts` works unconditionally.
 * @private
 * @hide
 */
export default [];